<template>
    <v-card
        flat
        :class="{ 'card': this.$vuetify.breakpoint.smAndUp }"
    >
        <v-card-text>
            <v-form>
                User E-Mail addresses are used for emailing tickets and other system messages.
                For Locators, you must enable 'Email Assigned Tickets' to have assigned tickets automatically
                e-mailed to this address.
                <v-text-field
                    v-model="email"
                    outlined
                    placeholder="Enter email address"
                    label="Email Address"
                    required
                    class="frmField"
                />
                If this user receives any tickets, specify the ticket format to send.
                <v-select
                    v-model="ticketFormat"
                    :items="items"
                    item-text="text"
                    item-value="value"
                    outlined
                    label="Ticket Format"
                    class="frmField"
                />
                <div
                    :class="{ 'bottomNav': !this.$vuetify.breakpoint.smAndUp }"                
                    class="d-flex mt-2"
                >
                    <v-btn
                        :class="{ 'mobile-btn': !this.$vuetify.breakpoint.smAndUp }"
                        outlined
                        class="mr-4"
                        @click="cancel"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        :class="{ 'mobile-btn': !this.$vuetify.breakpoint.smAndUp }"
                        depressed
                        color="primary"
                        @click="updateUser"
                    >
                        Update
                    </v-btn>
                </div>
            </v-form>
        </v-card-text>
    </v-card>
</template>
<script>
import webtmsBackend from '@/services/webtmsBackend';

export default {
    name: 'Email',
    props: {},
    data() {
        return {
            email: this.$store.getters.user.email,
            account: this.$store.getters.user.account,
            ticketFormat: this.$store.getters.user.EMAIL_TICKET_FORMAT,
            isMobile: this.$vuetify.breakpoint.mobile,
            items: [
                { text: 'Original Text ', value: 'ORIGINAL' },
                { text: 'Original HTML', value: 'ORIGHTML' },
                { text: 'Original Transmission', value: 'ORIGXMIT' },
                { text: 'SMS/TEXT Format', value: 'SMSTEXT' },
                { text: 'COMPANY Format 1', value: 'COMPANY_1' },
                { text: 'COMPANY Format 2', value: 'COMPANY_2' },
                { text: 'COMPANY Format 3', value: 'COMPANY_3' },
                { text: 'COMPANY Format 4', value: 'COMPANY_4' },
            ],
        };
    },
    methods: {
        postUser: async function() {
            await webtmsBackend.setUserObject(this.$store.getters.user);
        },
        postUserOptions: async function() {
            try {
                let options = [];
                options.push(['EMAIL_TICKET_FORMAT', this.ticketFormat]);

                await webtmsBackend.setUserOptions(options);
            } catch (error) {
                console.error(error);
            }
        },
        updateUser() {
            try {
                this.$store.dispatch('updateUserEmail', this.email);
                this.$store.dispatch('updateUserEmailTicketFormat', this.ticketFormat);
                this.postUser();
                this.postUserOptions();
                this.$store.dispatch('setSnackbar', {text:'Email information updated successfully!'});
                if(this.isMobile) {
                    this.$router.push({ path: '/profile' });
                }
            } catch (error) {
                this.$store.dispatch('setSnackbar', {color:'error',text:error.message});
            }
        },
        cancel() {
            this.email = this.$store.getters.user.email;
            this.ticketFormat = this.$store.getters.user.EMAIL_TICKET_FORMAT;
            this.$router.push({ path: '/profile' });
        },
    },
};
</script>
<style scoped>
.frmField{
      width: 348px;
      margin-top: 2em;
}
.card{
    width: 400px;
}

.bottomNav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0px;
  height: 80px;
  display: flex;
  background: var(--ll-surface);
  justify-content: center;
  padding: 16px 16px;
  border-top: 1px solid var(--ll-border);

}
.v-btn.mobile-btn{
  width: 134px;
  height: 48px;
  padding: 16px;
}
</style>
